import React, { useEffect } from 'react';
import { dispatcher } from 'dispatcher';

import { WebContent } from '@core/js/components/main/WebContent';

import { AdminComponent } from './components/AdminComponent';

import { componentService } from '@core/js/services/component.service';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TPortalPlaceProps } from './types';

import style from './PortalPlace.scss';

export const PortalPlace: React.FC<TPortalPlaceProps> = ({ id, dataId: dataIdProps, className, isHideAdminPanel, ...other }) => {
    const dataId = dataIdProps || other['data-id'];

    useEffect(() => {
        dispatcher.dispatch('portalPlace:update', id);
    }, [id, dataId]);

    useEffect(() => () => {
        dispatcher.dispatch('portalPlace:removed', id);
    }, [id]);

    return (
        <div
            id={id}
            data-id={dataId}
            className={clsx(style.container, className, other.classname, { [style.isHideAdminPanel]: isHideAdminPanel })}
        >
            <AdminComponent id={id} dataId={dataId} prefix="Place for" isHideAdminPanel={isHideAdminPanel} />
        </div>
    );
};

componentService.registerWebContentComponents({ PortalPlace });
componentService.registerPageComponents({ 'dynamic-web-content': WebContent });
